import React from "react";
import TradeDropDown from "./TradeDropDown";
import CategoryDropDown from "./CategoryDropDown";
import JobDropDown from "./JobDropDown";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";

const name = "EliminationSearch"

type Props = {
    parent: string
    inputRef:any;
}

const EliminationSearch: React.FC<Props> = ({ parent,inputRef }) => {
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, {})
    return (
        <>
            <TradeDropDown parent={debugName} />
            <CategoryDropDown parent={debugName} />
            <JobDropDown parent={debugName} inputRef={inputRef}/>
        </>
    )
}

export default React.memo(EliminationSearch)